/**********************************************************************************************************************/
/* FILE: display-fullmap/hafas_webapp_controller_print.js                                                             */
/**********************************************************************************************************************/
/* Controller PRINT */
HafasWebapp.prototype.Controller.PRINT = {
  common: {
    openPrintView: function (storageObj, type) {
      // ergebnis in session storage ablegen, druckansicht greift dann darauf zu
      var storageId = new Date().getTime();
      try {
        this.cleanupSessionStorage();
        sessionStorage.setItem('print_' + type + '_' + storageId, JSON.stringify(storageObj));
      } catch (e) {
        Hafas.Core.log('PRINT: Das Objekt konnte nicht gespeichert werden (' + type + ')');
      }

      // wenn L-Parameter aktiv, dann diesen an href weitergeben
      var layoutParam = '';
      if (Hafas.Core.getParameterByName("L") != null) {
        layoutParam = '&L=' + Hafas.Core.getParameterByName("L");
      }

      window.open('print.html?language=' + Hafas.Config.currLangObj.lang + '&mode=' + type + '&id=' + storageId + layoutParam, '_blank');
    },
    /**
     * cleans up session storage
     * is necessary, as session storage is limited
     */
    cleanupSessionStorage: function () {
      for (var prop in sessionStorage) {
        if (/print_\w+_\d+/.test(prop))
          sessionStorage.removeItem(prop);
      }
    }
  },

  tp: function (opts) {

    console.log(opts)
    var _me = this;
    var printviewObj = {};

    var connection;

    // get connection overview data
    _me.Controller.TP.currentTripResult.outConnections.forEach(function connOverView(currConn) {
      if (currConn.cid === opts.cid) {
        connection = currConn;

      }
    })
    if(typeof connection === "undefined"){
      _me.Controller.TP.currentTripResult.retConnections.forEach(function connOverView(currConn) {
        if (currConn.cid === opts.cid) {
          connection = currConn;

        }
      })
    }

    /*if(_me.Controller.TP.instance.isGroupingUsed()){
      Object.keys(_me.Controller.TP.instance.data.results.groups).forEach(function(group){
        _me.Controller.TP.instance.data.results.groups[group].connections.forEach(function(currConn){
          if(currConn.resolvedConnection.cksum === opts.connection){
            connection = currConn.resolvedConnection;
          }
        });
      });
    }
    else{
      _me.Controller.TP.instance.data.results.renderConnections.forEach(function(currConn){
        if(currConn.cksum === opts.connection){
          connection = currConn;
        }
      });
    }*/

    printviewObj.connection = connection;
    this.Controller.PRINT.common.openPrintView(printviewObj, 'tp');
  },

  jt: {
    errorOverview: function (opts) {
      if (opts.ev) {
        opts.ev.preventDefault();
      }

      var _me = this;
      var printWindow = null;

      var journeyTreeErrors = {};
      var template = "";
      if ((typeof opts.type != undefined) && (opts.type == "err_grouping")) {
        journeyTreeErrors.title = "Auflistung aller Fehler im Fahrtenbaum (Sortierung: Fehler)";
        journeyTreeErrors.groupedErrorList = _me.Controller.JT.resultData.minimizedErrorList;
        journeyTreeErrors.grouping = "errors";
      } else {
        journeyTreeErrors.title = "Auflistung aller Fehler im Fahrtenbaum (Sortierung: Pfade)";
        journeyTreeErrors.errorList = _me.Controller.JT.errorLog;
        journeyTreeErrors.grouping = "paths";
      }
      template = "JT_TplPrintErrorOverview";
      Hafas.Modules.Render.render({
        file: 'jt.print_errorOverview.html',
        template: template,
        model: journeyTreeErrors
      }, function (html) {

        // open javascript popup
        printWindow = window.open('', 'PrintOverview', 'resizable=yes,scrollbars=yes,status=yes', false);

        // clear content if popup is still open
        printWindow.document.getElementsByTagName('body')[0].innerHTML = '';

        // write new content
        printWindow.document.write(html);
        printWindow.document.close();

        if (!printWindow.opener) {
          printWindow.opener = self;
        }
        if (printWindow.focus()) {
          printWindow.focus();
        }
      });
    }
  },

  sq: {

    init: function (opts) {
      var printviewObj = {
        resolvedData: this.Controller.SQ.instance.resolvedData
      };

      this.Controller.PRINT.common.openPrintView(printviewObj, 'sq');
    }

  },

  timetable: {
    printTables: function (opts) {
      // console.log("+++ printTables +++");
      var result = this.Controller.Timetable.result;
      var printviewObj = {
        result: result
      };

      this.Controller.PRINT.common.openPrintView(printviewObj, 'timetable');
    }
  }
};
